module.exports = __webpack_public_path__ + "static/media/AB_K17_6.b010db34.jpg";